import React, { ReactNode } from "react";
import { Box } from "@waglabs/box-next";
export type StepProps = {
  active?: boolean;
  children: ReactNode;
};
export const Step = ({
  active,
  children
}: StepProps) => {
  if (!active) {
    return null;
  }

  return <Box>
      {children}
    </Box>;
};